import { render, staticRenderFns } from "./RescheduleAppointmentModal.vue?vue&type=template&id=5c475f5d&"
import script from "./RescheduleAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./RescheduleAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./RescheduleAppointmentModal.vue?vue&type=style&index=0&id=5c475f5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports